module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot02_stay-e62695e17db28c5a5586e772e618f756.jpg";